<script module lang="ts">
  export interface KeyHint {
    keys: string[];
    label: string;
  }
</script>

<script lang="ts">
  interface Props {
    hints: KeyHint[];
  }

  let { hints }: Props = $props();
</script>

{#if hints.length > 0}
  <ul class="keyhints" aria-label="ショートカット" data-testid="keyhints">
    {#each hints as hint (hint.label)}
      <li>
        {#each hint.keys as key (key)}<kbd>{key}</kbd>{/each}
        {hint.label}
      </li>
    {/each}
  </ul>
{/if}

<style>
  .keyhints {
    display: flex;
    gap: var(--space-2) var(--space-4);
    flex-wrap: wrap;
    justify-content: center;
    margin: var(--space-4) 0 0;
    padding: 0;
    list-style: none;
    font-size: var(--fs-xs);
    color: var(--text-soft);
  }
  @media (max-width: 639px) {
    .keyhints {
      display: none;
    }
  }
  kbd + kbd {
    margin-left: var(--space-1);
  }
</style>
